export const styles = {
  content: {
    float: "left",
    maxWidth: 545,
    marginLeft: 5,
    width: "100%",
  },
  textArea: {
    clear: "none",
    border: "1px solid rgba(34,36,38,.15)",
  },
  label_ctnr: {
    backgroundColor: "#F9F9FA",
    border: "1px solid rgba(34,36,38,.15)",
  },
};
